module.exports = __webpack_public_path__ + "static/media/12.e6299b29.jpg";